@if (!isLoading() && !hasBillingAccess()) {
<section
  class="tw-box-border tw-flex tw-flex-col tw-items-start tw-gap-6 tw-m-auto tw-pt-4 tw-px-4 lg:tw-px-6 tw-pb-6 tw-w-full tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-xl"
  id="billing"
>
  <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
    <h2 class="tw-font-inter tw-font-bold tw-text-lg tw-text-gray-700 dark:tw-text-gray-100">
      {{ 'v2.orgSettings.billing.billing' | translate }}
    </h2>
    <p class="tw-font-inter tw-font-normal tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
      {{ 'v2.orgSettings.billing.description' | translate }}
    </p>
  </div>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-w-full tw-py-10 tw-text-center">
    <img [src]="accessDeniedImage" alt="No access" class="tw-object-contain tw-h-[307px] tw-w-[460px] "/>
    <p class="tw-font-inter tw-font-semibold tw-text-xl tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100">
      {{ 'v2.orgSettings.billing.noBillingAccessTitle' | translate }}
    </p>
    <p class="tw-font-inter tw-font-normal tw-text-base tw-leading-5 tw-text-gray-500 dark:tw-text-gray-400 tw-max-w-xl">
      {{ 'v2.orgSettings.billing.noBillingAccessDescription' | translate }}
    </p>
  </div>
</section>
} @else {
<section
  class="tw-box-border tw-flex tw-flex-col tw-items-start tw-gap-6 tw-m-auto tw-pt-4 tw-px-4 lg:tw-px-6 tw-pb-6 tw-w-full tw-bg-white dark:tw-bg-gray-800 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-xl"
  id="billing"
>
  <div class="tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-start tw-gap-4 tw-w-full">
    <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
      <h2 class="tw-font-inter tw-font-bold tw-text-lg tw-text-gray-700 dark:tw-text-gray-100">
        {{ 'v2.orgSettings.billing.billing' | translate }}
      </h2>
      <p class="tw-font-inter tw-font-normal tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
        {{ 'v2.orgSettings.billing.description' | translate }}
      </p>
    </div>

    @if (customerId()) {
    <div class="tw-flex tw-flex-row tw-justify-end tw-items-center tw-gap-1 tw-shrink-0">
      <button
        type="button"
        class="tw-inline-flex tw-items-center tw-gap-1 tw-font-inter tw-font-medium tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-200 tw-transition-colors"
        [ngxTippy]="customerIdTippyContent()"
        [tippyProps]="{ placement: 'bottom', trigger: 'mouseenter focus click', touch: false }"
        (click)="copyCustomerId()"
      >
        <span class="tw-inline-flex tw-items-center tw-justify-center" [innerHTML]="icons.copy | safe"></span>
        <span>{{ customerId() }}</span>
      </button>

      <button
        type="button"
        class="tw-inline-flex tw-items-center tw-justify-center tw-w-5.5 tw-h-5.5 tw-cursor-default"
        [ngxTippy]="'v2.orgSettings.billing.customerIdInfo' | translate"
        [tippyProps]="{ placement: 'bottom', trigger: 'mouseenter focus', touch: false }"
        tabindex="-1"
        aria-hidden="true"
      >
        <span [innerHTML]="icons.info | safe"></span>
      </button>
    </div>
    }
  </div>

  <div
    class="tw-w-full lg:tw-mx-0 lg:tw-px-0 tw-overflow-x-auto lg:tw-overflow-visible tw-snap-x tw-snap-mandatory lg:tw-snap-none [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:tw-hidden"
  >
    <div class="tw-flex tw-flex-row tw-gap-2 tw-w-full lg:tw-grid lg:tw-grid-cols-2 lg:tw-gap-4">
      @if (!isLoading()) {
      <!-- Wallet balance card -->
      <div
        class="tw-box-border tw-flex tw-flex-col tw-items-start tw-justify-between tw-shrink-0 tw-snap-start tw-flex-[0_0_85%] lg:tw-flex-none lg:tw-w-full tw-py-4 tw-px-3 lg:tw-p-4 tw-h-36 tw-rounded-xl tw-border tw-border-gray-200 tw-bg-[linear-gradient(278.82deg,#3895FF_0%,#4364F7_50.37%,#1C64F2_100%)]"
      >
        <div class="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-w-full">
          <span class="tw-font-inter tw-font-normal tw-text-sm tw-text-gray-100">
            {{ 'v2.orgSettings.billing.walletBalance' | translate }}
          </span>
          <span class="tw-font-inter tw-font-bold tw-text-2xl tw-text-white">
            {{ walletBalance() | currency : 'USD' : 'symbol' : '1.2-2' }}
          </span>
        </div>

        <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-w-full">
          @if (defaultPaymentMethod(); as paymentMethod) {
          <button
            type="button"
            class="tw-box-border tw-flex tw-flex-[3] tw-basis-0 tw-min-w-0 tw-items-center tw-justify-start tw-h-10 tw-px-3 tw-border tw-border-white tw-rounded-md hover:tw-bg-white/10 tw-transition-colors"
            (click)="openPaymentCardsModal()"
          >
            <span class="tw-flex tw-w-full tw-min-w-0 tw-items-center tw-gap-2">
              <span class="tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-10 tw-h-5.5 tw-bg-white tw-border tw-border-gray-200 tw-rounded tw-overflow-hidden">
                <img [src]="getCardBrandIconUrlFn(paymentMethod.brand)" alt="" class="tw-w-full tw-h-full tw-object-contain" />
              </span>
              <span class="tw-flex tw-min-w-0 tw-flex-1 tw-pt-1 tw-items-start tw-flex-col tw-overflow-hidden">
                <span class="tw-font-inter tw-font-bold tw-text-sm tw-leading-3 tw-text-white tw-whitespace-nowrap"> •••• {{ paymentMethod.last4 }} </span>
                <span class="tw-font-inter tw-font-medium tw-text-[10px] lg:tw-text-md tw-text-gray-300 tw-whitespace-nowrap">
                  {{ 'v2.orgSettings.billing.expires' | translate }}: {{ formatCardExpiryFn(paymentMethod.exp_month, paymentMethod.exp_year) }}
                </span>
              </span>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_48055_33805)">
                  <path
                    d="M3.67863 12C3.44839 11.9999 3.22332 11.9296 3.0319 11.7979C2.84047 11.6662 2.69128 11.4791 2.60317 11.2601C2.51507 11.0411 2.49201 10.8002 2.53692 10.5677C2.58182 10.3353 2.69267 10.1217 2.85546 9.95411L6.68957 6.00736L2.85546 2.06061C2.74425 1.95005 2.65555 1.8178 2.59453 1.67158C2.53351 1.52535 2.50139 1.36808 2.50004 1.20894C2.4987 1.0498 2.52816 0.89198 2.5867 0.744686C2.64525 0.597391 2.7317 0.463573 2.84102 0.35104C2.95034 0.238507 3.08034 0.149513 3.22343 0.0892499C3.36653 0.0289869 3.51984 -0.00133763 3.67444 4.52529e-05C3.82904 0.00142813 3.98182 0.034491 4.12387 0.0973047C4.26593 0.160118 4.3944 0.251425 4.50181 0.365896L9.1591 5.16001C9.37738 5.38476 9.5 5.68956 9.5 6.00736C9.5 6.32517 9.37738 6.62997 9.1591 6.85472L4.50181 11.6488C4.28351 11.8736 3.9874 11.9999 3.67863 12Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_48055_33805">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          </button>

          <button
            type="button"
            class="tw-box-border tw-max-w-[35%] lg:tw-max-w-full tw-inline-flex tw-flex-[2] tw-basis-0 tw-min-w-0 tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-px-3 tw-py-2 tw-bg-white tw-rounded-md tw-font-inter tw-font-normal tw-text-sm tw-text-blue-600 hover:tw-bg-gray-100 tw-transition-colors"
            (click)="openWalletTopUpModal()"
          >
            <span class="tw-inline-flex tw-shrink-0 [&_svg]:tw-block" [innerHTML]="icons.add | safe"></span>
            <span class="tw-whitespace-nowrap tw-font-medium">{{ 'v2.orgSettings.billing.topUp' | translate }}</span>
          </button>
          } @else if (canEditBilling()) {
          <button
            type="button"
            class="tw-box-border tw-inline-flex tw-flex-1 tw-basis-0 tw-min-w-0 tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-px-3 tw-py-2 tw-rounded-md tw-border tw-border-white tw-font-inter tw-font-normal tw-text-sm tw-text-white hover:tw-bg-white/10 tw-transition-colors"
            (click)="openAddPaymentCardModal()"
          >
            <span class="tw-inline-flex tw-shrink-0 [&_svg]:tw-block" [innerHTML]="icons.card | safe"></span>
            <span class="tw-whitespace-nowrap tw-text-sm tw-font-medium">{{ 'v2.orgSettings.billing.addPaymentCard' | translate }}</span>
          </button>

          <button
            type="button"
            class="tw-box-border tw-inline-flex tw-max-w-[35%] lg:tw-max-w-full tw-flex-1 tw-basis-0 tw-min-w-0 tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-px-3 tw-py-2 tw-bg-white tw-rounded-md tw-font-inter tw-font-normal tw-text-sm tw-text-blue-600 hover:tw-bg-gray-100 tw-transition-colors"
            (click)="openWalletTopUpModal()"
          >
            <span class="tw-inline-flex tw-shrink-0 [&_svg]:tw-block" [innerHTML]="icons.add | safe"></span>
            <span class="tw-whitespace-nowrap">{{ 'v2.orgSettings.billing.topUp' | translate }}</span>
          </button>
          } @else {
          <button
            type="button"
            class="tw-box-border tw-inline-flex tw-flex-1 tw-basis-0 tw-min-w-0 tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-px-3 tw-py-2 tw-bg-white tw-rounded-md tw-font-inter tw-font-normal tw-text-sm tw-text-blue-600 hover:tw-bg-gray-100 tw-transition-colors"
            (click)="openWalletTopUpModal()"
          >
            <span class="tw-inline-flex tw-shrink-0 [&_svg]:tw-block" [innerHTML]="icons.add | safe"></span>
            <span class="tw-whitespace-nowrap tw-font-medium">{{ 'v2.orgSettings.billing.topUp' | translate }}</span>
          </button>
          }
        </div>
      </div>

      <!-- Current plan card -->
      <div
        class="tw-box-border tw-flex tw-flex-col tw-items-start tw-justify-between tw-shrink-0 tw-snap-start tw-flex-[0_0_85%] lg:tw-flex-none lg:tw-w-full tw-py-4 tw-px-3 lg:tw-p-4 tw-h-36 tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-bg-white dark:tw-bg-gray-800"
      >
        <div class="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-w-full">
          <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-w-full">
            <span class="tw-font-inter tw-font-normal tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
              {{ 'v2.orgSettings.billing.currentPlan' | translate }}
            </span>
            <span
              class="tw-inline-flex tw-items-center tw-justify-center tw-px-2.5 tw-py-0.5 tw-rounded tw-font-inter tw-font-normal tw-text-xs ]"
              [ngClass]="isBasicPlan() ? 'tw-bg-blue-50 tw-text-blue-800' : 'tw-bg-green-100 tw-text-green-800'"
            >
              {{ planName() }}
            </span>
          </div>

          <div class="tw-flex tw-flex-row tw-justify-between tw-items-end tw-gap-2 tw-w-full">
            <span class="tw-font-inter tw-leading-1" [ngClass]="isManuallyUpgraded() ? 'tw-text-sm' : 'tw-text-2xl'">
              <span class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100">{{ planPriceAmount() }}</span>
              @if (planPriceSuffix()) {
              <span class="tw-font-normal tw-text-gray-500 tw-text-sm dark:tw-text-gray-400">{{ planPriceSuffix() }}</span>
              }
            </span>
            @if (planExpiryDate()) {
            <span class="tw-font-inter tw-font-medium tw-text-xs tw-text-right tw-text-gray-500 dark:tw-text-gray-400 tw-shrink-0">
              {{ 'v2.orgSettings.billing.expires' | translate }}: {{ planExpiryDate() }}
            </span>
            }
          </div>
        </div>

        <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-w-full">
          <button
            type="button"
            class="tw-inline-flex tw-flex-1 tw-basis-0 tw-min-w-0 tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-px-3 tw-py-2 tw-rounded-md tw-bg-blue-600 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-font-inter tw-font-normal tw-text-sm tw-text-white tw-transition-colors"
            (click)="openCustomerPortal()"
            [disabled]="!canEditBilling()"
            [ngClass]="{ 'hover:tw-bg-blue-600/90 dark:hover:tw-bg-blue-900/90 tw-transition-colors': canEditBilling() }"
          >
            <span
              class="tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-3 tw-h-3 [&_svg]:tw-block [&_svg]:tw-w-full [&_svg]:tw-h-full"
              [innerHTML]="icons.settings | safe"
            ></span>
            <span class="tw-whitespace-nowrap">{{ 'v2.orgSettings.billing.manageSubscription' | translate }}</span>
          </button>
          <!-- TODO: Add this button back in when the design is ready  lg:tw-inline-flex and remove the hidden class -->
          <button
            type="button"
            class="tw-box-border tw-hidden tw-shrink-0 tw-flex-none tw-w-9 tw-h-10 tw-items-center tw-justify-center tw-p-2 tw-rounded-md tw-border tw-border-blue-600 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-colors"
            (click)="openCustomerPortal()"
            [disabled]="!canEditBilling()"
            [ngxTippy]="'v2.orgSettings.billing.openCustomerPortal' | translate"
            [tippyProps]="{ placement: 'top', trigger: 'mouseenter focus', touch: false }"
          >
            <span
              class="tw-inline-flex tw-items-center tw-justify-center tw-w-3 tw-h-3 [&_svg]:tw-block [&_svg]:tw-w-full [&_svg]:tw-h-full"
              [innerHTML]="icons.edit | safe"
            ></span>
          </button>
        </div>
      </div>
      } @else {
      <div
        class="tw-box-border tw-flex tw-flex-col tw-justify-between tw-shrink-0 tw-snap-start tw-flex-[0_0_85%] lg:tw-flex-none lg:tw-w-full tw-p-4 tw-h-36 tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600"
      >
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '120px', height: '16px', 'border-radius': '6px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
          animation="pulse"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '180px',
            height: '30px',
            'border-radius': '8px',
            marginTop: '8px',
            backgroundColor: getSkeletonTheme().backgroundColor,
            color: getSkeletonTheme().color
          }"
          animation="pulse"
        ></ngx-skeleton-loader>
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-w-full">
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '164px', height: '37px', 'border-radius': '6px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '100%', height: '37px', 'border-radius': '6px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
      </div>

      <div
        class="tw-box-border tw-flex tw-flex-col tw-justify-between tw-shrink-0 tw-snap-start tw-flex-[0_0_85%] lg:tw-flex-none lg:tw-w-full tw-p-4 tw-h-36 tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-600"
      >
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '120px', height: '16px', 'border-radius': '6px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
          animation="pulse"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '180px',
            height: '30px',
            'border-radius': '8px',
            marginTop: '8px',
            backgroundColor: getSkeletonTheme().backgroundColor,
            color: getSkeletonTheme().color
          }"
          animation="pulse"
        ></ngx-skeleton-loader>
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-w-full">
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '164px', height: '37px', 'border-radius': '6px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '100%', height: '37px', 'border-radius': '6px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
      </div>
      }
    </div>
  </div>

  @if (isLoading()) {
  <div class="tw-flex tw-flex-col tw-items-start tw-gap-4 tw-w-full tw-min-h-[28rem]" aria-hidden="true">
    <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-gap-4 tw-w-full">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '160px',
          height: '24px',
          'border-radius': '6px',
          backgroundColor: getSkeletonTheme().backgroundColor,
          color: getSkeletonTheme().color
        }"
        animation="pulse"
      ></ngx-skeleton-loader>
    </div>
    <div
      class="tw-flex tw-w-full tw-min-h-[24rem] tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700"
    >
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '100%',
          height: '64px',
          'border-radius': '0',
          backgroundColor: getSkeletonTheme().backgroundColor,
          color: getSkeletonTheme().color
        }"
        animation="pulse"
      ></ngx-skeleton-loader>
      @for (row of [1, 2, 3, 4, 5]; track row) {
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '100%',
          height: '64px',
          'border-radius': '0',
          marginTop: '0',
          backgroundColor: getSkeletonTheme().backgroundColor,
          color: getSkeletonTheme().color
        }"
        animation="pulse"
      ></ngx-skeleton-loader>
      }
    </div>
  </div>
  } @else if (hasBillingAccess()) {
  <app-billing-transactions class="tw-block tw-w-full"></app-billing-transactions>
  }
</section>

<app-billing-payment-cards-modal
  [modalId]="paymentCardsModalId"
  [addPaymentCardModalId]="addPaymentCardModalId"
  [headerIcon]="icons.addPaymentCard"
  [paymentMethods]="paymentMethods()"
  [isProPlan]="isProPlan()"
  [canEditPaymentCards]="canEditBilling()"
  [removingPaymentMethodId]="removingPaymentMethodId()"
  [getCardBrandIconUrl]="getCardBrandIconUrlFn"
  [formatCardBrand]="formatCardBrandFn"
  [formatCardExpiry]="formatCardExpiryFn"
  (setDefault)="setDefaultPaymentMethod($event)"
  (remove)="removePaymentMethod($event)"
></app-billing-payment-cards-modal>

<app-billing-add-payment-card-modal [modalId]="addPaymentCardModalId" [headerIcon]="icons.add" [setAsDefaultByDefault]="!hasPaymentMethods()"></app-billing-add-payment-card-modal>

<app-billing-wallet-top-up-modal
  [modalId]="walletTopUpModalId"
  [headerIcon]="icons.topUpModal"
  [paymentMethods]="paymentMethods()"
  [getCardBrandIconUrl]="getCardBrandIconUrlFn"
  [formatCardBrand]="formatCardBrandFn"
  [formatCardExpiry]="formatCardExpiryFn"
  (topUpSuccess)="onWalletTopUpSuccess($event)"
></app-billing-wallet-top-up-modal>
}
